import * as React from "react";
import { Spinner } from "components/common";
import { useLegacyEventNotificationTypes } from "components/event-notifications/hooks/useEventNotifications";
import LegacyNotificationSummary from "./LegacyNotificationSummary";
const LegacyNotificationSummaryContainer = ({ ...props }) => {
  const { data } = useLegacyEventNotificationTypes();
  const allLegacyTypes = data == null ? void 0 : data.types;
  if (!allLegacyTypes) {
    return /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(Spinner, { text: "Loading legacy notification information..." }));
  }
  return /* @__PURE__ */ React.createElement(LegacyNotificationSummary, { ...props, legacyTypes: allLegacyTypes });
};
export default LegacyNotificationSummaryContainer;
